/**
 * 首页
 */
export default [
  {
    path: '/',
    meta: {
      title: '首页'
    },
    component: (resolve) => {
      require(['$views/index/index.vue'], resolve)
    }
  },
  {
    path: '/activity',
    meta: {
      title: '新人有礼'
    },
    component: (resolve) => {
      require(['$views/activity/index.vue'], resolve)
    }
  },
  {
    path: '/investment',
    meta: {
      title: '随手记投资 | 随手动态-用户信赖的金融服务平台'
    },
    component: (resolve) => {
      require(['$views/investment/index.vue'], resolve)
    }
  },
  {
    path: '/my-assets',
    meta: {
      title: '我的资产'
    },
    component: (resolve) => {
      require(['$views/my-assets/my-assets.vue'], resolve)
    }
  },
  {
    path: '/pdf',
    meta: {
      title: 'pdf'
    },
    component: (resolve) => {
      require(['$views/pdf/index.vue'], resolve)
    }
  },
  {
    path: '/pz',
    meta: {
      title: '投资'
    },
    component: (resolve) => {
      require(['$views/pinzhuan/index.vue'], resolve)
    },
  },
  {
    path: '/mouthly-report',
    meta: {
      title: '运营月报'
    },
    component: (resolve) => {
      require(['$views/mouthly-report/index.vue'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes/modules/index.js